import { api, type ApiResponse } from '../client';
import apiClient from '../client';

export interface Employer {
  uuid: string;
  name: string;
  abn?: string;
  contact_name?: string;
  contact_email?: string;
  contact_phone?: string;
  head_office_location?: string;
}

class EmployersSearchService {
  private baseUrl = '/employer';

  /**
   * Search employers by phrase (name, ABN, etc.)
   * @param phrase Search query
   * @param limit Maximum number of results to return
   * @returns Promise with list of matching employers
   */
  async searchEmployers(phrase: string = '', limit: number = 10): Promise<Array<{uuid: string, name: string}>> {
    try {
      // Require phrase to be at least 2 characters
      if (!phrase || phrase.trim().length < 2) {
        return [];
      }
      
      const params = new URLSearchParams();
      params.append('phrase', phrase.trim());
      params.append('per_page', limit.toString());
      params.append('page', '1');

      const axiosResponse = await apiClient.get(`${this.baseUrl}?${params.toString()}`);
      
      // The axios response.data IS the server JSON
      const serverResponse = axiosResponse.data;
      
      if (serverResponse && serverResponse.success && serverResponse.data && Array.isArray(serverResponse.data)) {
        return serverResponse.data.map((employer: Employer) => ({
          uuid: employer.uuid,
          name: employer.name
        }));
      }
      
      return [];
    } catch (error: any) {
      console.error('Error searching employers:', error);
      return [];
    }
  }

  /**
   * Get employer by UUID (for getting selected label)
   * @param uuid Employer UUID
   * @returns Promise with employer name or null
   */
  async getEmployerName(uuid: string): Promise<string | null> {
    try {
      const response = await api.get<{success: boolean, data: Employer}>(`${this.baseUrl}/${uuid}`);
      
      if (response.data.success && response.data.data) {
        return response.data.data.name;
      }
      
      return null;
    } catch (error: any) {
      console.error('Error getting employer name:', error);
      return null;
    }
  }
}

export const employersSearchService = new EmployersSearchService();
export default employersSearchService;

